import { Component, Input, forwardRef } from '@angular/core'
import {
  ControlValueAccessor,
  FormGroup,
  NG_VALUE_ACCESSOR
} from '@angular/forms'
import { DateAdapter } from '@angular/material/core'
import { MatFormFieldAppearance } from '@angular/material/form-field'

export interface DateRangeValue {
  from: Date | null
  to: Date | null
}

import { ReactiveFormsModule } from '@angular/forms'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatDatepickerModule } from '@angular/material/datepicker'

@Component({
  selector: 'app-date-range-picker',
  templateUrl: './date-range-picker.component.html',
  styleUrls: ['./date-range-picker.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DateRangePickerComponent),
      multi: true
    }
  ],
  standalone: true,
  imports: [ReactiveFormsModule, MatFormFieldModule, MatDatepickerModule]
})
export class DateRangePickerComponent implements ControlValueAccessor {
  @Input() label: string = 'From-To'
  @Input() fromPlaceholder: string = 'From'
  @Input() toPlaceholder: string = 'To'
  @Input() cancelLabel: string = 'Cancel'
  @Input() applyLabel: string = 'Apply'
  @Input() showApplyButton: boolean = true
  @Input() formGroup!: FormGroup
  @Input() fromControlName: string = 'from'
  @Input() toControlName: string = 'to'
  @Input() appearance: MatFormFieldAppearance = 'fill'
  @Input() width: string = '100%'
  @Input() cssClass: string = 'date-range-picker'
  @Input() calendarIcon: string = 'assets/images/icons/calender.svg'
  currentLanguage = localStorage.getItem('lang')

  private onChange = (value: DateRangeValue) => {
    console.log(value)
  }
  private onTouched = () => {}

  get value(): DateRangeValue {
    return {
      from: this.formGroup?.get(this.fromControlName)?.value || null,
      to: this.formGroup?.get(this.toControlName)?.value || null
    }
  }

  constructor(private dateAdapter: DateAdapter<Date>) {
    this.setCalenderLanguage()
  }
  onApplyClick(): void {
    const dateRange = this.value
    this.onChange(dateRange)
  }

  onDateChange(): void {
    const dateRange = this.value
    this.onChange(dateRange)
  }

  // ControlValueAccessor implementation
  writeValue(value: DateRangeValue): void {
    if (value && this.formGroup) {
      this.formGroup
        .get(this.fromControlName)
        ?.setValue(value.from, { emitEvent: false })
      this.formGroup
        .get(this.toControlName)
        ?.setValue(value.to, { emitEvent: false })
    }
  }

  registerOnChange(fn: (value: DateRangeValue) => void): void {
    this.onChange = fn
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn
  }

  setDisabledState(isDisabled: boolean): void {
    if (this.formGroup) {
      if (isDisabled) {
        this.formGroup.get(this.fromControlName)?.disable()
        this.formGroup.get(this.toControlName)?.disable()
      } else {
        this.formGroup.get(this.fromControlName)?.enable()
        this.formGroup.get(this.toControlName)?.enable()
      }
    }
  }

  setCalenderLanguage() {
    if (this.currentLanguage === 'ar') {
      this.dateAdapter.setLocale('ar-EG')
    } else {
      this.dateAdapter.setLocale('en-GB')
    }
  }
}
